module.exports = __webpack_public_path__ + "img/logo.3d924c5b.png";